import * as ReactGA from 'react-ga'

export function logEvent(action: string, label?: string): void {
  ReactGA.event({
    category: 'Consumer Portal',
    action,
    label,
  })
}
